import { render, staticRenderFns } from "./ctaBlockModule.vue?vue&type=template&id=1e571e60&scoped=true&"
import script from "./ctaBlockModule.vue?vue&type=script&lang=js&"
export * from "./ctaBlockModule.vue?vue&type=script&lang=js&"
import style0 from "./ctaBlockModule.vue?vue&type=style&index=0&id=1e571e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e571e60",
  null
  
)

export default component.exports